// Component-local cached options query — ADR-3 select precedent
// (core/components/CurrencySelect/useCurrencySelect.ts). Shared with
// CreditCardProviderInlineCreate, which appends each provider it creates.
export const CREDIT_CARD_PROVIDER_OPTIONS_QUERY_KEY = [
  'selects',
  'credit-card-providers',
]
